export default "__VITE_ASSET__D0PSZloE__"